import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {AppContext} from "../../authProvider/AuthProvider";
import {GameMode} from "../../../models/GameMode";
import {GameApi} from "../../../services/api/GameApi";

export const PagesLink: React.FC = () => {
    const { t } = useTranslation();
    const { isConnected } = useContext(AppContext);
    const [ gameTheme, setGameTheme ] = useState<GameMode[]>([]);

    useEffect(() => {
        GameApi.getGameTheme().then((data) => {
            setGameTheme(data)
        })
    }, []);

    return (
        <div className="flex flex-col justify-center h-full md:border-r-darkpurple-blue md:border-r">

            <p className=" opacity-50 ">
                {t("global.game-mods")}
            </p>

            {
                gameTheme.map((element) => {
                    return (
                        <Link
                            key={element.id}
                            to={`/chooseGameMode/${element.id}`}
                            className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}
                        >
                            {t("game."+(element.name)?.toLowerCase())}
                        </Link>
                    )
                })
            }

            <p className=" mt-20 opacity-50 ">
                {t("global.socials")}
            </p>

            <Link
                to={"/leaderboard"}
                className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}>
                {t("global.leaderboard")}
            </Link>

            <Link
                to={"/stats"}
                className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}>
                {t("global.stats")}
            </Link>

            <Link
                to={"/players"}
                className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}>
                {t("global.players")}
            </Link>
            {
                isConnected ? (
                    <Link
                        to={"/account"}
                        className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}>
                        {t("global.account")}
                    </Link>
                ) : (
                    <Link
                        to={"/login"}
                        className={`transition-all mt-3 text-xl ease-out hover:text-pink text-justify`}>
                        {t("form.connect")}
                    </Link>
                )
            }


        </div>
    )
}
